import { render } from "./ButtonElement.vue?vue&type=template&id=40d37d38&scoped=true"
import script from "./ButtonElement.vue?vue&type=script&lang=js"
export * from "./ButtonElement.vue?vue&type=script&lang=js"

import "./ButtonElement.vue?vue&type=style&index=0&id=40d37d38&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40d37d38"]])

export default __exports__